<template>
  
    <Favorites ref="favRef" />

</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";


export default {
    name: "CallsList",
    components: {

    },
    data() {
        return {
            categories: [],
            subCategories: [],
            isLoading: true,
            token: localStorage.getItem("access_token"),
            courseCount: 0,
            isLoggedIn: false,
            walletBalance: 0,
            catImagePath: baseUrl + "/images/category/",
            defaultImage: "/assets/img/acad-icon.png",
            student: {},
            loadingCategories: true, // Loading state for categories
            loadingCourses: true, // Loading state for courses
            loadingBalance: true, // Loading state for wallet balance
            currentStep: 1, // بداية في الخطوة 1
            selectedOption: "", // البيانات للـ select box
            textInput: "", // البيانات للـ input text
            numberInput: "", // البيانات للـ input number
            isChecked: false, // البيانات للـ checkbox
        };
    },
    mounted() {
        this.getBalance();
    },
    methods: {

        async getBalance() {
            this.isLoading = true; // Start loading
            try {
                const response = await fetch(
                    `${apiUrl}/wallets/get-balance?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    this.walletBalance = data.wallet_balance;
                    this.isLoading = false;
                    this.isLoggedIn = true;

                } else {
                    console.error("Failed to fetch balance");
                    this.isLoading = false;

                }
            } catch (error) {
                console.error("Error fetching balance:", error);
            } finally {
                this.loadingBalance = false; // Stop loading
                this.isLoading = false;
            }
        },
        formatDate(date) {
            const options = {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            };
            return new Date(date).toLocaleDateString("en-US", options);
        },
        handleImageError(event) {
            // استبدال الصورة بصورة افتراضية إذا حدث خطأ مثل 404
            event.target.src = this.defaultImage;
        }
    },
};
</script>

<style scoped></style>
